Fancybox.bind("[data-fancybox]", {});

document.querySelector('.search-modal__close-button').addEventListener('click', function () {
  const el = document.querySelector('.header__search details');
  el.removeAttribute('open');
});

// ------- Menu drawer --------
const menuBtn = document.querySelector('.header__icon--menu');
const menuDrawer = document.querySelector('.menu-drawer-container');
const menuClose = document.querySelector('.menu-close');
const menuOverlay = document.querySelector('.menu-drawer-container .cart-drawer__overlay');
const body = document.querySelector('body');

menuBtn.addEventListener('click', function () {
  menuDrawer.classList.add('is-active');
  body.classList.add('overflow-hidden');
});

menuClose.addEventListener('click', function () {
  menuDrawer.classList.remove('is-active');
  body.classList.remove('overflow-hidden');
});

menuOverlay.addEventListener('click', function () {
  menuDrawer.classList.remove('is-active');
  body.classList.remove('overflow-hidden');
});

const menuItems = document.querySelectorAll('.menu-drawer__menu-item');
const menuCloseButtons = document.querySelectorAll('.menu-drawer__close-button');

// Add .is-active to clicked parent
menuItems.forEach(item => {
  item.addEventListener('click', function () {
    const parent = this.closest('.has-sub-menu');
    if (!parent) return;

    parent.classList.add('is-active');
  });
});

// Remove .is-active ONLY when clicking close button inside sub-menu
menuCloseButtons.forEach(btn => {
  btn.addEventListener('click', function () {
    const parent = this.closest('.has-sub-menu');
    if (!parent) return;

    parent.classList.remove('is-active');
  });
});


// ----- Product media slider ------
// GLOBAL references (important)
window.mainSlider = null;
window.thumbSlider = null;

window.initFlickity = function () {

  // Destroy if already initialized
  if (window.mainSlider) {
    window.mainSlider.destroy();
    window.mainSlider = null;
  }

  if (window.thumbSlider) {
    window.thumbSlider.destroy();
    window.thumbSlider = null;
  }

  // MAIN SLIDER
  window.mainSlider = new Flickity('.product__media-list', {
    cellAlign: 'left',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    wrapAround: true,
  });

  // THUMBNAIL SLIDER
  window.thumbSlider = new Flickity('.thumbnail-list', {
    asNavFor: '.product__media-list',
    contain: true,
    pageDots: false,
    prevNextButtons: true,
    draggable: true,
    cellAlign: 'left',
    wrapAround: true,
    groupCells: 4
  });

  // Sync thumbnail clicks → main slider
  window.thumbSlider.on('staticClick', function (event, pointer, cellElement, cellIndex) {
    if (typeof cellIndex === 'number') {
      window.mainSlider.select(cellIndex);
    }
  });

};

// First load
window.initFlickity();


$(document).ready(function () {  

  /* ==========================
     WOW.js Initialization
  ========================== */
  new WOW().init();
  /* ==========================
     Sticky Header on Scroll
  ========================== */
  window.addEventListener("scroll", function () {
    if (window.scrollY > 350) {
      document.body.classList.add("sticky-header");
    } else {
      document.body.classList.remove("sticky-header");
    }
  });

  /* ==========================
     Shadow Overlay (Mobile Menu)
  ========================== */
  if (!$(".shadow-overlay").length) {
    $("body").prepend("<div class='shadow-overlay'></div>");
  }

  /* ==========================
     Mobile Menu Toggle
  ========================== */
  $(".menu-toggle-btn, .header-inner-logo .close-icon, .shadow-overlay").on("click", function () {
    $("body").toggleClass("nav-open overflow-hidden");
  });

  /* ==========================
     Tabs 
  ========================== */
$(".style-sec, .bestSeller-sec").each(function () {
  const $tabSection = $(this);

  $tabSection.find(".tab-button").click(function () {
    const target = $(this).data("target");

    // Handle active tab switching
    $tabSection.find(".tab-button").removeClass("active");
    $(this).addClass("active");

    $tabSection.find(".tab-panel").removeClass("active").hide();
    const $targetPanel = $tabSection.find("#" + target);

    $targetPanel.addClass("active").show(); // 👈 instantly show

    // Optional: if you still want fade animation, do it *after* show()
    $targetPanel.css({ opacity: 0 }).animate({ opacity: 1 }, 600);

    // ✅ Immediately refresh slick layout
    const $slider = $targetPanel.find(".bestseller-slider");
    if ($slider.hasClass("slick-initialized")) {
      $slider.slick("setPosition");
    }
  });
});


  /* ==========================
     sliders
  ========================== */
  $(".hero-slider").slick({
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: true,
    fade: true,
    speed: 800,
  });
  // ✅ Explore Slider
  if ($(window).width() > 767) {
  $(".explore-slider").slick({
    dots: false,
    speed: 1000,
    slidesToShow: 3.4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3.1
        }
      }
    ]
  });
}


  // ✅ Trending Slider
  $(".trending-slider").slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 1000,
    slidesToShow: 3.4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    infinite: true,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2.7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2.3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.8,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  $(".spotlight-slider, .bestseller-slider").slick({
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 4.7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1299,
        settings: {
          slidesToShow: 4.4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3.7,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3.2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 568,
        settings: {
          slidesToShow: 2.1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
        },
      },
    ],
  });

  /* ----------------------------
     Back To Top Btn
  ---------------------------- */

  $(function () {
    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 300) {
        $(".back-to-top-btn").addClass("show");
      } else {
        $(".back-to-top-btn").removeClass("show");
      }
    });

    $(".back-to-top-btn").on("click", function (e) {
      $("html, body").animate({ scrollTop: 0 }, 300);
    });
  });

  /* ----------------------------
    accordian
  ---------------------------- */

  function enableAccordion() {
    if ($(window).width() <= 767) {
      /* --- Footer Section --- */
      $(".foot-col").each(function () {
        let title = $(this).find(".footer-title");

        if (!title.find(".acc-icon").length) {
          title.append('<span class="icon acc-icon"></span>');
        }

        if (!$(this).find(".foot-content").length) {
          let content = $(this).children("ul, p, .social-icons");
          content.wrapAll('<div class="foot-content"></div>');
        }
      });

      $(".foot-content").hide();

      $(".footer-title")
        .off("click")
        .on("click", function () {
          let content = $(this).next(".foot-content");
          let icon = $(this).find(".acc-icon");

          content.slideToggle();
          icon.toggleClass("open");

          $(".footer-title")
            .not(this)
            .each(function () {
              $(this).find(".acc-icon").removeClass("open");
              $(this).next(".foot-content").slideUp();
            });
        });

      /* --- Search Section --- */
      $(".search-category").each(function () {
        let title = $(this).find(".title");

        if (!title.find(".acc-icon").length) {
          title.append('<span class="icon acc-icon"></span>');
        }

        if (!$(this).find(".search-content").length) {
          let links = $(this).find("a");
          links.wrapAll('<div class="search-content"></div>');
        }
      });

      $(".search-content").hide();

      $(".title")
        .off("click")
        .on("click", function () {
          let content = $(this).next(".search-content");
          let icon = $(this).find(".acc-icon");

          content.slideToggle();
          icon.toggleClass("open");

          $(".title")
            .not(this)
            .each(function () {
              $(this).find(".acc-icon").removeClass("open");
              $(this).next(".search-content").slideUp();
            });
        });
    } else {
      $(".foot-content").show();
      $(".acc-icon").remove();

      $(".search-content").show();
    }
  }

  enableAccordion();

  $(window).on("resize", function () {
    enableAccordion();
  });

  $("#bottom-nav #search").on("click", function () {
  $(".header__search details").attr("open", true);
  $(this).addClass("actives");
});

$(".header__search details").on("toggle", function () {
  if (!this.open) {
    // Remove actives when search drawer closes
    $("#bottom-nav #search").removeClass("actives");
  }
});
});

window.initSizeChart = function () {
  // size chart
  $(".tab-btn").on("click", function () {
    $(".tab-btn").removeClass("active");
    $(this).addClass("active");

    let target = $(this).data("tab");

    $(".sc-table").removeClass("active").hide();
    $(".sc-" + target)
      .addClass("active")
      .fadeIn(200);
  });

  $(".size-chart-label").on("click", function () {
    $(".size-chart-modal").addClass("active").fadeIn(200);
  });

  // Close Modal
  $(".sc-close").on("click", function () {
    $(".size-chart-modal").removeClass("active").fadeOut(200);
  });
}

window.initSizeChart();